"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _controlCheckboxSet = _interopRequireDefault(require("./control-checkbox-set"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _controlCheckboxSet.default;
exports.default = _default;